import React from 'react';
import classNames from 'classnames';
import { bool, element, func, number, oneOfType, string } from 'prop-types';

import { Icon } from 'common/components/Icon';
import { TranslatedMessage } from 'common/components/Intl';
import QuantityInput from 'common/components/QuantityInput';

const wrapWithLink = (element, url, className = '') => {
  if (!url) {
    return element;
  }

  return (
    <a href={url} className={className}>
      {element}
    </a>
  );
};

const LineItem = ({
  className,
  details,
  imageUrl,
  name,
  onQuantityChange,
  onRemove,
  quantity,
  quantityControls,
  quantityMaximum,
  price,
  url,
}) => {
  return (
    <div className={classNames('line-item', className)}>
      {wrapWithLink(
        <img className="line-item__image" src={`${imageUrl}?w=120`} />,
        url,
        'line-item__image-link'
      )}

      <div className="line-item__info">
        <h4 className="line-item__name heading--small">
          {wrapWithLink(name, url, 'line-item__name-link')}
        </h4>

        {details && (
          <div className="line-item__meta subheading--small">{details}</div>
        )}

        <div className="line-item__quantity-and-prices">
          <div className="line-item__quantity">
            <label className="line-item__quantity-label subheading--small">
              <TranslatedMessage id="quantity" />
            </label>
            <QuantityInput
              compact={true}
              controls={quantityControls}
              maximum={quantityMaximum}
              onChange={onQuantityChange}
              value={quantity}
            />
          </div>
          <div className="line-item__prices">{price}</div>
        </div>

        {onRemove && (
          <Icon
            className="line-item__remove"
            name="trash-can"
            onClick={onRemove}
          />
        )}
      </div>
    </div>
  );
};

LineItem.defaultProps = {
  quantityControls: true,
  quantityMaximum: Infinity,
};

LineItem.propTypes = {
  className: string,
  details: oneOfType([string, element]),
  originalPrice: oneOfType([string, element]),
  imageUrl: string.isRequired,
  name: string.isRequired,
  onQuantityChange: func,
  onRemove: func,
  price: element.isRequired,
  quantity: number.isRequired,
  quantityControls: bool,
  quantityMaximum: number,
  url: string,
};

export default LineItem;
